import { lazy } from 'react';

export const PlayerForfeitActiveBonusForm = lazy(
  () => import('./PlayerForfeitActiveBonusForm'),
);
